import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FlexContainer,
  HorizontalTabs,
} from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import SearchInputs from "../../../constants/DeliveryDrivers/SearchInputs.json";
import FilterInputs from "../../../constants/DeliveryDrivers/FilterInputs.json";
import Button from "sushiweb/Button";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import * as CarrierActions from "../../../store/actions/Carriers";
import {
  checkIfKeysPresent,
  isObjectStateEmpty,
  isValNull,
  removeEmptyVals,
} from "../../../utils";
import InitialStates from "./initialState.json";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";

const filterKeys = [
  "city_id",
  "locality_id",
  "partner_status",
  "partner_state",
  "partner_services",
  "carrier_id",
];
const searchkeys = ["driver_id", "id", "phone_no", "license_no", "pan_no"];

const FilterSearchBar = ({
  applyFilters,
  getCityList,
  getLocalityList,
  cityList,
  localityList,
  clearFilters,
  getDriverLifecycleStatuses,
  getDriverDeliveryStatuses,
  getDriverDeliveryServices,
  driverDeliveryStatuses,
  driverDeliveryServices,
  driverLifecycleStatuses,
  carriersList,
  getCarriersList,
  nextPageCity,
  nextPageLocality,
  driverListFilters,
  getCity,
  getLocality,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [initialState, setInitialState] = useState({ ...InitialStates });
  const [priorityFlag, setPriorityFlag] = useState(false);

  const handleClick = (index) => (e) => {
    setActiveIndex(index);
  };

  const getOptions = (key) => {
    switch (key) {
      case "city":
        return cityList;
      case "locality":
        return localityList;
      case "partner_status":
        return driverDeliveryStatuses;
      case "partner_service":
        return driverDeliveryServices;
      case "partner_state":
        return driverLifecycleStatuses;
      case "carrier":
        return carriersList;
      default:
        return [];
    }
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    if (key === "city_id") {
      values["locality_id"] = "";
      setPriorityFlag(true);
    } else if (key === "locality_id") {
      setPriorityFlag(false);
    }
    setInitialState(values);
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();
    if (action === "apply") {
      applyFilters(removeEmptyVals(initialState));
    } else {
      clearFilters();
      setActiveIndex(0);
      setInitialState({ ...InitialStates });
    }
  };

  const getValue = (key, val) => {
    if (key === "city") {
      const activeCity = cityList.find((item) => item.id === val);
      return activeCity ? activeCity.city_name : "";
    } else if (key === "locality") {
      const activeLocality = localityList.find((item) => item.id === val);
      return activeLocality ? activeLocality.locality_name : "";
    } else if (key === "carrier") {
      const activeCarrier = carriersList.find((item) => item.id === val);
      return activeCarrier ? activeCarrier.carrier_type : "";
    } else {
      return val;
    }
  };

  const getModalState = () => {
    const updatedObj = { ...driverListFilters };
    delete updatedObj.login_status;
    if (Object.keys(updatedObj).length > 0) {
      return "Edit";
    } else {
      return "Filter";
    }
  };

  const enableActiveIndex = (obj) => {
    let idx = 0;
    const filterKeysPresent = checkIfKeysPresent(obj, filterKeys);
    const searchKeysPresent = checkIfKeysPresent(obj, searchkeys);
    if (filterKeysPresent && !searchKeysPresent) {
      idx = 1;
    }
    setActiveIndex(idx);
  };

  const getCount = (type) => {
    const keys = type === "search" ? searchkeys : filterKeys;
    let count = 0;
    keys.forEach((key) => {
      if (!isValNull(initialState[key])) {
        count++;
      }
    });
    return count;
  };

  const checkIfButtonDisabled = (btnType) => {
    let updatedState = { ...initialState };
    if (btnType === "clear") {
      updatedState = { ...driverListFilters };
    }
    if (updatedState.page) {
      delete updatedState.page;
    }
    if (updatedState.login_status) {
      delete updatedState.login_status;
    }
    if (isObjectStateEmpty(updatedState)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    driverLifecycleStatuses.length === 0 && getDriverLifecycleStatuses();
    driverDeliveryStatuses.length === 0 && getDriverDeliveryStatuses();
    driverDeliveryServices.length === 0 && getDriverDeliveryServices();
    carriersList.length === 0 && getCarriersList();
  }, []);

  useEffect(() => {
    const updatedObj = { ...driverListFilters };
    delete updatedObj.login_status;
    setInitialState(updatedObj);
    if (Object.keys(updatedObj).length > 0) {
      setPriorityFlag(true);
    } else {
      setPriorityFlag(false);
    }
    enableActiveIndex(driverListFilters);
  }, [driverListFilters]);

  return (
    <FilterSearchBox
      className="containsDropdown mr-10"
      onSubmit={(e) => handleSubmit(e, "apply")}
    >
      <HorizontalTabs className="mb-18">
        <HorizontalTabs.Link
          className="searchIndex"
          active={activeIndex === 0}
          onClick={handleClick(0)}
        >
          <span>
            SEARCH{" "}
            {getCount("search") > 0 && (
              <sup style={{ color: variables.white }}>
                ({getCount("search")})
              </sup>
            )}
          </span>
        </HorizontalTabs.Link>
        <HorizontalTabs.Link
          active={activeIndex === 1}
          onClick={handleClick(1)}
        >
          <span>
            FILTER {getCount("filter") > 0 && <sup>({getCount("filter")})</sup>}
          </span>
        </HorizontalTabs.Link>
      </HorizontalTabs>
      {activeIndex ? (
        <React.Fragment>
          <InfiniteScrollDropdown
            id="cityFilterDropdown"
            className="sushi-dropdown"
            priorityFlag={true}
            appliedFilters={{}}
            getActiveList={getCityList}
            nextPage={nextPageCity}
            resKey="cities"
            modalState={getModalState()}
            keyName="city_id"
            labelKey="city_name"
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            label="City"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            activeElement={initialState}
            getActiveItemById={getCity}
          />
          <InfiniteScrollDropdown
            id="localityFilterDropdown"
            className="sushi-dropdown"
            priorityFlag={priorityFlag}
            setPriorityFlag={setPriorityFlag}
            appliedFilters={
              initialState.city_id ? { city_id: initialState.city_id } : {}
            }
            getActiveList={getLocalityList}
            nextPage={nextPageLocality}
            resKey="localities"
            modalState={getModalState()}
            keyName="locality_id"
            labelKey="locality_name"
            getDataLabelKey="locality.locality_name"
            keyTypeToSet="id"
            label="Locality"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            activeElement={initialState}
            getActiveItemById={getLocality}
          />
          {FilterInputs.inputs.slice(2).map((field, index) => {
            return (
              <PaginatedReactDropdown
                options={getOptions(field.optionsKey)}
                disabled={field.disabled}
                labelKey={field.labelKey}
                valueKey={field.valueKey}
                labelWidth={field.labelWidth}
                key={index}
                id={field.optionsKey + "_dropdown"}
                optionsBoxId={field.optionsKey + "_options"}
                value={getValue(
                  field.optionsKey,
                  initialState[field.keyToChange]
                )}
                handleChange={handleChange}
                keyToChange={field.keyToChange}
                placeholder={field.placeholder}
                showCross
                // showPagination={shouldShowPagination(field.optionsKey)}
                // nextPage={getNextPage(field.optionsKey)}
                // handleNextPage={handleNextPage}
                // extraParamsPagination={[field.optionsKey]}
              />
            );
          })}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {SearchInputs.inputs.map((field, index) => {
            return (
              <Input
                onChange={(e) => handleChange(field.name, e)}
                value={initialState[field.name]}
                data-testid={`input-field-${field.name}`}
                key={index}
                type={field.isNumber ? "number" : undefined}
                id="sushi-input"
                label={field.label}
              />
            );
          })}
        </React.Fragment>
      )}
      <FlexContainer>
        <Button
          onClick={(e) => handleSubmit(e, "clear")}
          disabled={checkIfButtonDisabled("clear")}
          className="sushi-btn mr-10"
          appearance="outline"
        >
          Clear
        </Button>
        <Button
          // onClick={() => handleSubmit("apply")}
          disabled={checkIfButtonDisabled("apply")}
          className="sushi-btn"
          data-testid="filtersApply"
          type="submit"
        >
          Apply
        </Button>
      </FlexContainer>
    </FilterSearchBox>
  );
};

const FilterSearchBox = styled.form`
  padding: 18px;
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;

  #sushi-input {
    margin-bottom: 14px;
  }

  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon
    .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
    border-radius: 8px;
    padding: 10px 18px;
    box-sizing: border-box;
    height: unset;
  }
  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${variables.grey300};
  }
  .MuiFormLabel-root.Mui-focused {
    color: ${variables.grey700};
  }
  .MuiAutocomplete-popupIndicator {
    margin-right: 8px;
  }
  .cross {
    opacity: 0.5;
    width: 15px;
    height: auto;
    margin-right: 10px;
  }
  .MuiInputLabel-outlined {
    transform: translate(20px, 15px) scale(1);
    &.MuiInputLabel-shrink {
      transform: translate(10px, -8px) scale(0.8);
    }
  }
  .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
    .MuiAutocomplete-input {
    padding: 2px 4px;
  }

  .partner_status_options > div {
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { City, Locality, DeliveryDrivers, Carriers } = state;
  return {
    cityList: City.cityList,
    localityList: Locality.localityList,
    driverLifecycleStatuses: DeliveryDrivers.driverLifecycleStatuses,
    driverDeliveryStatuses: DeliveryDrivers.driverDeliveryStatuses,
    driverDeliveryServices: DeliveryDrivers.driverDeliveryServices,
    carriersList: Carriers.carriersList,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
    driverListFilters: DeliveryDrivers.driverListFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    getDriverDeliveryStatuses: bindActionCreators(
      DeliveryDriversActions.getDriverDeliveryStatuses,
      dispatch
    ),
    getDriverDeliveryServices: bindActionCreators(
      DeliveryDriversActions.getDriverDeliveryServices,
      dispatch
    ),
    getDriverLifecycleStatuses: bindActionCreators(
      DeliveryDriversActions.getDriverLifecycleStatuses,
      dispatch
    ),
    getCarriersList: bindActionCreators(
      CarrierActions.getCarriersList,
      dispatch
    ),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterSearchBar);
